import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatPipe } from './date-format.pipe';

@Pipe({
  name: 'backorderedDate',
  standalone: false,
})
/**
 * @deprecated
 */
export class BackorderedDatePipe implements PipeTransform {
  constructor(private dateFormat: DateFormatPipe) {}

  transform(key: Array<any>, args?): string {
    let estimated = 'Estimated Ship date: ';

    const dates: string[] = [];
    key.forEach((itemDate) => {
      let currentDate = '';
      if (itemDate.date === 'now') {
        currentDate = 'Arriving Soon';
      } else if (new Date(itemDate.date) < new Date()) {
        currentDate = 'Arriving Soon';
      } else {
        currentDate = String(
          this.dateFormat.transform(itemDate.date, 'MMMM D, YYYY')
        );
      }
      if (!dates.includes(currentDate)) {
        dates.push(currentDate);
      }
    });

    if (dates.length > 1) {
      estimated = 'Estimated Ship dates: ';
    }

    return estimated + dates.join(' and ');
  }
}
